export function jfTrashPin() {
    return {
        scope: {
            treeBrowser: '='
        },
        restrict: 'E',
        controller: JFTrashPinController,
        controllerAs: 'jfTrashPin',
        bindToController: true,
        template: `<i class="icon icon-pin trash-pin"
                      ng-class="{'icon-pin': !jfTrashPin.treeBrowser.isTrashPinned(), 'icon-unpin': jfTrashPin.treeBrowser.isTrashPinned()}"
                      ng-style="{left: jfTrashPin.getLeftPosition()}" 
                      ng-click="jfTrashPin.treeBrowser.toggleTrashPin($event); jfTrashPin.updateTooltipText()"  
                      jf-tooltip="{{jfTrashPin.tooltipText}}"></i>`
    }
}


class JFTrashPinController {
    constructor($element) {
        this.$element = $element;
    }

    $onInit() {
        this.updateTooltipText();
    }

    updateTooltipText() {
        this.tooltipText = !this.treeBrowser.isTrashPinned() ? 'Pin Trash Can' : 'Unpin Trash Can';
    }

    getLeftPosition() {
        let trashPin = $(this.$element).find('.trash-pin');
        let hScroll = trashPin.parents('.h-scroll-wrapper');
        return hScroll.scrollLeft() + hScroll.parent().width() - 50 + 'px';
    }

}



// WEBPACK FOOTER //
// ./states/artifacts/jf_tree_browser/jf_trash_pin.js